document.addEventListener('DOMContentLoaded', function() {
    if (!window.customer?.isLoggedIn) {
        window.location.href = '/account/login';
        return;
    }

    const fontsGrid = document.getElementById('fontsGrid');
    const loadingSpinner = document.getElementById('loadingSpinner');
    const noFontsMessage = document.getElementById('noFontsMessage');

    fetch(`https://i.wahup.com/api/fonts/?customer_id=${window.customer.id}`)
        .then(response => response.json())
        .then(data => {
            loadingSpinner.style.display = 'none';
            
            // Check if data is an object with fonts property or an array
            const fontArray = Array.isArray(data) ? data : (data.fonts || []);
            
            if (!fontArray || fontArray.length === 0) {
                noFontsMessage.style.display = 'block';
                return;
            }

            fontArray.forEach(font => {
                const fontCard = createFontCard(font);
                fontsGrid.appendChild(fontCard);
            });
        })
        .catch(error => {
            console.error('Error fetching fonts:', error);
            loadingSpinner.style.display = 'none';
            noFontsMessage.style.display = 'block';
        });
});

function createFontCard(font) {
    const card = document.createElement('div');
    card.className = 'font-card';
    card.setAttribute('data-font-id', font.id);
    
    const previewChars = font.characters.slice(0, 6);
    
    card.innerHTML = `
        <div class="font-preview">
            ${previewChars.map(char => `
                <img src="${char.image_data}" alt="${char.char}" class="preview-char">
            `).join('')}
        </div>
        <div class="font-info">
            <h3 class="font-name">${font.name}</h3>
            <p class="font-description">${font.description || 'No description'}</p>
            <div class="font-actions">
                <button class="action-btn download-btn" onclick="downloadFont('${font.id}')">
                    <span class="btn-icon">⬇️</span>
                    Download
                </button>
                <button class="action-btn delete-btn" onclick="showDeleteDialog('${font.id}', '${font.name}')">
                    <span class="btn-icon">🗑️</span>
                    Delete
                </button>
            </div>
        </div>
    `;
    
    return card;
}

function downloadFont(fontId) {
    const fontCard = document.querySelector(`[data-font-id="${fontId}"]`);
    if (!fontCard) {
        console.error('Font card not found');
        return;
    }

    const downloadBtn = fontCard.querySelector('.download-btn');
    if (!downloadBtn) {
        console.error('Download button not found');
        return;
    }

    downloadBtn.disabled = true;
    downloadBtn.innerHTML = '<span class="btn-icon">⏳</span> Downloading...';

    fetch(`https://i.wahup.com/api/fonts/${fontId}/download/?customer_id=${window.customer.id}`)
        .then(response => {
            if (!response.ok) throw new Error('Download failed');
            return response.blob();
        })
        .then(blob => {
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `font-${fontId}.zip`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
            
            // Reset button
            downloadBtn.disabled = false;
            downloadBtn.innerHTML = '<span class="btn-icon">⬇️</span> Download';
        })
        .catch(error => {
            console.error('Error downloading font:', error);
            downloadBtn.disabled = false;
            downloadBtn.innerHTML = '<span class="btn-icon">⬇️</span> Download';
            alert('Failed to download font. Please try again later.');
        });
}

function showDeleteDialog(fontId, fontName) {
    const dialog = document.createElement('div');
    dialog.className = 'delete-dialog';
    
    dialog.innerHTML = `
        <div class="delete-content">
            <h3>Delete Font</h3>
            <p>Are you sure you want to delete "${fontName}"?<br>This action cannot be undone.</p>
            <div class="delete-actions">
                <button class="cancel-delete" onclick="this.closest('.delete-dialog').remove()">Cancel</button>
                <button class="confirm-delete" onclick="deleteFont('${fontId}', this)">Delete</button>
            </div>
        </div>
    `;
    
    document.body.appendChild(dialog);
}

function deleteFont(fontId, button) {
    button.disabled = true;
    button.textContent = 'Deleting...';

    fetch(`https://i.wahup.com/api/fonts/${fontId}/?customer_id=${window.customer.id}`, {
        method: 'DELETE'
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to delete font');
            }
            
            const dialog = button.closest('.delete-dialog');
            const fontCard = document.querySelector(`[data-font-id="${fontId}"]`);
            
            dialog.remove();
            if (fontCard) {
                fontCard.style.animation = 'fadeOut 0.3s ease forwards';
                setTimeout(() => fontCard.remove(), 300);
            }

            const fontsGrid = document.getElementById('fontsGrid');
            if (fontsGrid.children.length === 1) { // Changed from 0 to 1 because current card hasn't been removed yet
                document.getElementById('noFontsMessage').style.display = 'block';
            }
        })
        .catch(error => {
            console.error('Error deleting font:', error);
            button.disabled = false;
            button.textContent = 'Delete';
            
            // Show more descriptive error message
            if (error.response?.status === 403) {
                alert('You do not have permission to delete this font.');
            } else {
                alert('Failed to delete font. Please try again later.');
            }
        });
} 